/* eslint-disable import/prefer-default-export */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */

import moment from 'moment';

export function getDayOptionsForMonth(number, t) {
  if (!number) {
    number = 1;
  }
  const days = [{ value: null, label: t('scheduler.newClient.dayDropdownLabel') }];
  // why 2000? We need 29 days in February.
  const numOfDays = moment(`${number.toString()}-2000`, 'MM-YYYY').daysInMonth();
  for (let i = 1; i <= numOfDays; i++) {
    days.push({ value: i, label: i.toString() });
  }

  return days;
}

export const checkIfDatesAreCorrect = (chosenDay, chosenMonth) =>
  // the dates are ok if Both are chosen, Both are not chosen (null) OR have been chosen but now their value is
  // or "day" option in the drop down menu) back to null (the client have press the "month"
  !(chosenDay || chosenMonth) ||
  (chosenDay && chosenMonth && ((chosenDay.value && chosenMonth.value) || !(chosenDay.value || chosenMonth.value)));

export const getStatusText = (status) => {
  switch (status) {
    case 'unconfirmed':
      return 'Unconfirmed';
    case 'deleted':
      return 'Deleted';
    case 'confirmed':
      return 'Confirmed';
    case 'arrived':
      return 'Needs Checkout';
    case 'finished':
    case 'paid':
      return 'Checked out';
    case 'no_show':
      return 'No Show';
    case 'preferred':
      return 'Preferred stylist';
    case 'canceled':
      return 'Cancelled';
    case 'customer_unverified':
      return 'Customer unverified';
    case 'Transaction voided':
      return 'Transaction voided';
    default:
      return 'Unknown Status';
  }
};

export const getBookingOriginText = (origin, frequency, frequencyType, isRepeating, until) => {
  if (isRepeating) {
    return `Repeats every ${frequency} ${frequencyType} until ${moment(until).format('MMM Do YYYY')}`;
  }

  switch (origin) {
    case 'salon_created':
      return 'Booked via phone / in-person';
    case 'online_rebooking':
      return 'Online Rebooking';
    case 'online_booking':
      return 'Booked online';
    case 'quick_setup':
      return 'Created by Quick Setup';
    default:
      return 'Unknown Origin';
  }
};

// FIXME: seems unused, delete it
export const calculateCheckouts = (bookings) => {
  let sum = 0;

  if (bookings) {
    bookings.forEach((booking) => {
      if (booking.status !== 'deleted' && booking.status !== 'canceled' && booking.status !== 'no_show') {
        sum += 1;
      }
    });
  }

  return sum;
};

export const calculateTotalPrice = (procedures) => {
  let sum = 0;
  procedures.forEach((procedure) => {
    sum += procedure.price;
  });

  return sum;
};

// FIXME: seems unused, delete it
export const getFirstSmsOfStatus = (smsRecords, type) => {
  for (let i = 0; i < smsRecords.length; i++) {
    if (smsRecords[i].status === type) {
      return smsRecords[i];
    }
  }

  return null;
};

export const filterOutHey = (smsRecords, type) => {
  const showList = [];
  for (let i = 0; i < smsRecords.length; i++) {
    if (smsRecords[i].status === type && smsRecords[i].text.indexOf('Hey! ') < 0) {
      showList.push(smsRecords[i]);
    }
  }

  return showList;
};

export const generateHistoricBookingsData = (response) =>
  response.reduce((prev, curr) => {
    if (!curr.appointment) {
      curr.appointment = {
        id: 0,
        notes: '',
        origin: 'salon_created',
        procedures: [],
        status: 'paid',
        transaction: curr.transaction,
        timestamp: curr.timestamp,
        frequency: '',
        frequency_type: '',
        until: '',
        is_repeating: false,
      };
    }
    let isHistory = true;
    // if appointment is after now and not paid, they will be included in scheduled appointment
    if (moment(curr.timestamp).isAfter(moment())) {
      if (curr.appointment && curr.appointment.status && curr.appointment.status !== 'paid') {
        isHistory = false;
      }
    }
    if (isHistory && curr.appointment) {
      curr.appointment.transaction = curr.transaction;
      curr.appointment.timestamp = curr.timestamp;
      prev.push(curr.appointment);
    }
    return prev;
  }, []);

export const groupProducts = (products) => {
  const response = [];
  products.forEach((product) => {
    if (product.id) {
      if (!response[product.id]) {
        response[product.id] = { ...product, totalPrice: product.finalPrice, amount: 1 };
      } else {
        response[product.id].amount += 1;
        response[product.id].totalPrice += product.finalPrice;
      }
    }
  });

  return response;
};
